const updatePositionsFormCopy = {
  cancelButtonLabel: 'Cancel',
  inputPlaceholder_positionQuantity: 'Quantity Held',
  inputPlaceholder_price: 'Price',
  saveButtonLabel: 'Update'
};

export default updatePositionsFormCopy;
